import { render, staticRenderFns } from "./DelegatedAccounts.vue?vue&type=template&id=1a0b3527"
import script from "./DelegatedAccounts.vue?vue&type=script&lang=js"
export * from "./DelegatedAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports